import Grid from '@mui/material/Grid';
import { Paper, Stack } from '@mui/material';
import { DateRangePicker, DateRange, LocalizationProvider } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import 'dayjs/locale/de';
import PageHeader from '../../../common/Components/PageHeader';

function Playlists() {
    const [dateRange, setDateRange] = useState<DateRange<Dayjs>>([dayjs(), dayjs().add(1, 'day')]);
    
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <PageHeader title='Cabin Cast - Playlists'>
                <Stack direction='row' spacing={2}> 
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='de'>
                        <DateRangePicker value={dateRange} onChange={setDateRange} slotProps={{ textField: { size: 'small' } }} />
                    </LocalizationProvider>
                </Stack>
                    
                </PageHeader>
            </Grid>
            <Grid item xs={12}>
                <Paper sx={{ p: 0, display: 'flex', flexDirection: 'column', minHeight: '100px' }} elevation={3}>
                    
                </Paper>
            </Grid>
        </Grid>
    );
}

export default Playlists;